import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, useParams } from 'react-router-dom';

import { getPaymentData } from './PaymentService';
import QRTicketInfo  from './QRTicketInfo';
import QRTicketInfoVMT  from './QRTicketInfoVMT';

import { QRCodeSVG } from 'qrcode.react';
import ErrorMessage from '../ErrorMessage';
import './css/ticket.css';
const QRTicket = () => {
    const { id } = useParams();
    const [payData, setPayData] = useState('');

    //для проверки выполнеения только один раз
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            hasFetched.current = true;
            async function fetchData() {
                const payment = await getPaymentData(id);
                //console.log("payment: ", payment)
                setPayData(payment);
            }

            fetchData();
        }
    }, []); // Пустой массив зависимостей

    return (
        <div>

            
            {payData.ticket!=null &&<QRTicketInfoVMT ticket={payData.ticket} payment={payData.payment}/>}
            <div style={{ marginTop: '20px' }}>
                {payData.code == 0 && payData.payment != null && <QRCodeSVG value={JSON.stringify(payData.payment, null, 2)} size={256} />}
                {payData.message != null && <ErrorMessage message={payData.message}/>}
            </div>
        </div>
    );
}



export default QRTicket;